export const searchFetchContact = (url, uid) => fetch(url, {
  method: "POST",
  body: new URLSearchParams({
    uid: uid.toString()
  })
}).then((response) => response.status === 404 ? void 0 : response.json());
